

























export default {
  name: 'search-box',
  data() {
    return {
      searchInput: '',
      showResults: false,
      locationResult: [],
      lastSearch: undefined
    }
  },
  created() {
    window.addEventListener('keydown', this.escape)
  },
  methods: {
    escape(event) {
      if (this.$data.showResults && event.keyCode === 27) {
        this.showResults = false
        if (document.activeElement) {
          document.activeElement.blur()
        }
      }
    },
    open(location) {
      // this.$store.dispatch('runtime/showDragSurface')
      // setTimeout(() => {
      //   this.$store.dispatch('runtime/hideDragSurface')
      // }, 500)
      this.showResults = false
      this.$router.push({
        name: 'app',
        params: {
          name: location.properties.name,
          region: location.properties.region,
          country: location.properties.country,
          lat: location.geometry.coordinates[1],
          lon: location.geometry.coordinates[0],
          zoom: 11
        }
      })
    },
    delayedBlur() {
      setTimeout(() => {
        this.showResults = false
      }, 1000)
    }
  },
  computed: {
    focusQuery() {
      const center = this.$store.state.persistent.center
      return `&focus.point.lat=${center.lat}&focus.point.lon=${center.lon}`
    }
  },
  watch: {
    showResults() {
      if (this.showResults === false) {
        this.searchInput = ''
      }
    },
    searchInput() {
      if (this.searchInput === '') {
        this.locationResult = []
      }

      if (this.searchInput === this.lastSearch) {
        return
      }

      this.lastSearch = this.searchInput

      if (this.searchInput.length < 3) return

      // console.log('Search ' + this.searchInput)

      const query = `https://api-search.meteo-parapente.com/v1/autocomplete?text=${this.searchInput}${this.focusQuery}`
      this.$http.get(query)
        .then(({ body: response }) => {
          if (this.searchInput !== response.geocoding.query.text) return
          this.locationResult = response.features
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/search-box.vue